import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { MachineRepository } from "@/repositories/machine-repository"
import { type IMachine } from "@/interfaces/api/machine.interface"
import { useMachineStore } from "@/store/machines.store"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { Machine } from "@/models/machine.model"

export class MachineController extends GenericModelController<
  Machine,
  IMachine,
  MachineRepository
> {
  constructor() {
    const machineStore = useMachineStore()
    const { machines } = storeToRefs(machineStore)
    const storeFunctionsConfig = {
      collection: machines
    }

    super(Machine, storeFunctionsConfig, new MachineRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(Machine, machines)
  }
}
